import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createResource } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for creating a Resource.
 */
export const useCreateResource = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call createResource.
     * @param {Pella.ProductionRequestAPI.CreateResourceInput} input - The inputs for creating the Resource.
     */
    mutationFn: (input) => createResource(input),
    onSuccess: () => {
      toast.success('Resource created successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RESOURCE_DATA] });
    },
  });
};
